<template>
  <div>
    <!-- 弹窗：开启 COSBrowser 客户端 -->
    <qc-dialog class="tc-15-rich-dialog cos" type="custom" :show="innerOpenShow"
      :title="$t('core.download_instructions')" :default-cancel="false" @close="closeOpenDialog" :width="550">
      <div class="download-alert-dialog">
        <p>
          <i18n path="cos.tips.multi_download[0]" tag="label" for="cos.tips.install_latest_client">
            <a :href="downloadUrl" target="_blank">{{$t('cos.tips.install_latest_client')}}</a>
          </i18n>
        </p>
        <div class="cos-select-download-box" style="text-align:center">
          <img src="//imgcache.qq.com/open_proj/proj_qcloud_v2/mc_2014/cos/css/img/cos-browser-logo.svg"
            :alt="`${$t('cos.cosBrowser')}logo`" width="100">
          <h4>{{$t('cos.cosBrowser')}}</h4>
        </div>
      </div>

      <div slot="button">
        <qc-button type="default" @click="openCosBrowser">{{$t('cos.confirm.open_cosbrowser')}}</qc-button>
      </div>
    </qc-dialog>

    <!-- 弹窗：重启 COSBrowser 客户端 -->
    <qc-dialog class="tc-15-rich-dialog cos" type="custom" :show.sync="innerReloadShow" :default-cancel="false">
      <div class="tc-icon-box mb-10">
        <div class="col">
          <i class="m-error-icon"></i>
        </div>
        <div class="col">
          <h3 class="tc-dialog-title">
            {{$t('state.fail.restart_cosbrowser')}}
          </h3>
          <p>
            <i18n path="cos.tips.multi_download[1]" tag="label" for="cos.tips.install_latest_client">
              <a :href="downloadUrl" target="_blank">{{$t('cos.tips.install_latest_client')}}</a>
            </i18n>
          </p>
        </div>
      </div>

      <div slot="button">
        <qc-button type="default" @click="openCosBrowser">{{$t('cos.confirm.restart_cosbrowser')}}</qc-button>
        <qc-button type="weak" @click="closeReloadDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
      </div>
    </qc-dialog>

    <!-- 弹窗：加载 COSBrowser 客户端 -->
    <qc-dialog type="custom" :show.sync="innerLoadShow" :no-close-button="true" :default-cancel="false" :width="450">
      <div class="tc-icon-box mb-25" style="display:block;margin-top:-28px;padding:0;text-align:center">
        <div class="col" style="display:inline-block;width:auto">
          <i class="n-loading-icon cos-select-loading-icon" style="width: 32px;height: 32px;margin-right: 10px;"></i>
        </div>
        <div class="col" style="display:inline-block">
          <h3 class="tc-dialog-title">{{$t('cos.tips.multi_download[2]')}}...</h3>
        </div>
      </div>
    </qc-dialog>

  </div>
</template>

<script>
import { getInnerProps, tips } from '@/scripts/tools/utils';
import downloader from '@/scripts/helper/downloader';

export default {
  props: {
    openShow: {
      type: Boolean,
      required: true,
      default: false,
    },
    loadShow: {
      type: Boolean,
      required: true,
      default: false,
    },
    reloadShow: {
      type: Boolean,
      required: true,
      default: false,
    },
    selectedList: {
      type: Array,
      required: true,
    },
    bucketInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    innerOpenShow: getInnerProps('openShow'),
    innerLoadShow: getInnerProps('loadShow'),
    innerReloadShow: getInnerProps('reloadShow'),
  },
  data() {
    return {
      downloadUrl:
        `https://${
          this.$store.officialDomain
        }/document/product/436/11366#.E4.B8.8B.E8.BD.BD.E4.B8.8E.E5.AE.89.E8.A3.85`,
    };
  },
  methods: {
    openCosBrowser() {
      this.innerOpenShow = false;
      this.innerReloadShow = false;
      this.innerLoadShow = true;

      const { Bucket, Region } = this.bucketInfo;
      const { selectedList } = this;
      downloader
        .addDownloadTask({ Bucket, Region, selectedList })
        .then(() => {
          this.innerLoadShow = false;
        })
        .catch(err => {
          this.innerLoadShow = false;
          if (err === 'reload') {
            this.innerReloadShow = true;
          } else {
            tips.error(err.message || err);
          }
        });
    },
    closeOpenDialog() {
      this.innerOpenShow = false;
    },
    closeLoadDialog() {
      this.innerLoadShow = false;
    },
    closeReloadDialog() {
      this.innerReloadShow = false;
    },
  },
};
</script>
